export const RACES = [
  { img: "luigicircuit.jpg", name: "luigi", devTime: "01:26.277" },
  { img: "Peach_Beach.PNG", name: "plage", devTime: "01:20.404" },
  { img: "baby_park.PNG", name: "baby park", devTime: "01:11.108" },
  { img: "desert secsec.jpg", name: "desert", devTime: "01:50.755" },
  { img: "pont champignon.jpg", name: "pont champi", devTime: "01:31.458" },
  { img: "MarioCircuit.jpg", name: "mario", devTime: "01:41.384" },
  { img: "paquebot.PNG", name: "paquebot", devTime: "01:52.207" },
  { img: "stade waluigi.jpg", name: "stade", devTime: "01:59.658" },
  { img: "royaume sorbet.jpg", name: "glace", devTime: "01:25.904" },
  { img: "champiville.jpg", name: "champivil", devTime: "01:50.663" },
  { img: "circuit yoshi.PNG", name: "yoshi", devTime: "01:59.886" },
  { img: "montagne dk.jpg", name: "montagne", devTime: "02:12.639" },
  { img: "arene wario.jpg", name: "arene", devTime: "02:21.106" },
  { img: "jungle dindino.jpg", name: "jungle", devTime: "02:00.908" },
  { img: "chateau bowser.jpg", name: "château", devTime: "02:44.690" },
  { img: "route arc en ciel.PNG", name: "arcenciel", devTime: "03:16.476" },
];

export type RaceResult = {
  j1: number;
  j2: number;
  comment?: string;
  date?: Date;
  stars: number;
  bigGuyIsLast: boolean;
  chronoInMs: number;
};

export type Race = {
  name: string;
  img: string;
  result: RaceResult;
};

export type ChelemModel = {
  _id?: string;
  courses: Race[];
  nb: number;
  ptsJ1: number;
  ptsJ2: number;
  date?: Date;
};

export type RaceDTO = {
  course_id: number;
  j1: number;
  j2: number;
  comment: string;
  stars?: number;
  date: Date | undefined;
  bigGuyIsLast: boolean;
  chronoInMs?: number;
};

export type ChelemDTO = {
  _id?: string;
  courses: RaceDTO[];
  nb: number;
  ptsJ1: number;
  ptsJ2: number;
  date: Date;
};

export const sortChelemRaces = (r1: Race, r2: Race): number => {
  if (r1.result.date && r2.result.date) {
    return r1.result.date.getTime() - r2.result.date.getTime();
  }
  if (r2.result.date) {
    return 1;
  }
  if (r1.result.date) {
    return -1;
  }

  return (
    RACES.findIndex((r) => r.name === r1.name) -
    RACES.findIndex((r) => r.name === r2.name)
  );
};

export const dtoToModel = (chelemDto: ChelemDTO): ChelemModel => {
  const chelem: ChelemModel = {
    ...chelemDto,
    date: chelemDto.date ? new Date(chelemDto.date) : chelemDto.date,
    courses: chelemDto.courses
      .map((c) => ({
        name: RACES[c.course_id - 1].name,
        img: RACES[c.course_id - 1].img,
        result: {
          j1: c.j1,
          j2: c.j2,
          comment: c.comment,
          stars: c.stars || 0,
          date: c.date ? new Date(c.date) : c.date,
          bigGuyIsLast: c.bigGuyIsLast,
          chronoInMs: c.chronoInMs || 0,
        },
      }))
      .sort(sortChelemRaces),
  };
  return chelem;
};

export const modelToDTO = (chelemModel: ChelemModel): ChelemDTO => {
  const chelem: ChelemDTO = {
    ...chelemModel,
    date: chelemModel.date || new Date(),
    courses: chelemModel.courses.map((c) => ({
      course_id: RACES.findIndex((r) => r.name === c.name) + 1,
      j1: c.result.j1,
      j2: c.result.j2,
      stars: c.result.stars,
      comment: c.result.comment || "",
      date: c.result.date,
      bigGuyIsLast: c.result.bigGuyIsLast || false,
      chronoInMs: c.result.chronoInMs || 0,
    })),
  };
  return chelem;
};

export type RaceTopChrono = {
  chronoInMs: number;
  date: Date | null;
};
export type RaceStats = {
  [name: string]: RaceTopChrono[];
};

export const initialChelem: ChelemModel = {
  nb: 0,
  ptsJ1: 0,
  ptsJ2: 0,
  courses: RACES.map((r) => ({
    ...r,
    result: { j1: 0, j2: 0, stars: 0, bigGuyIsLast: false, chronoInMs: 0 },
  })),
};
